import { UserState } from './types';
import { UserAction } from './actions';
import { initialState } from './constants';

export function diligenceUserReducer(state: UserState = initialState, action: UserAction) {
    return state;
}